import { render, staticRenderFns } from "./ImageSelectorMultiple.vue?vue&type=template&id=458bd52a&scoped=true&lang=pug&"
import script from "./ImageSelectorMultiple.vue?vue&type=script&lang=js&"
export * from "./ImageSelectorMultiple.vue?vue&type=script&lang=js&"
import style0 from "./ImageSelectorMultiple.vue?vue&type=style&index=0&id=458bd52a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458bd52a",
  null
  
)

/* custom blocks */
import block0 from "@/lang/components/imageSelectorMultiple.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fsrc%2Fcomponents%2FImageSelectorMultiple.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports